import { localeFullCode } from '../../../shared/useUtils';
import { TrustFactsStyle } from '../../../styles/components/common/blocks';

export interface ITrustFact {
  value: number;
  description: string;
}

export interface ITrustFactsProps {
  locale: string;
  facts: ITrustFact[];
}

const TrustFacts = (props: ITrustFactsProps) => {
  return (
    <div className={TrustFactsStyle['trust-facts']}>
      {props.facts.map((fact, index) => (
        <div key={index} className={TrustFactsStyle['trust-fact']}>
          <p className={TrustFactsStyle['trust-fact-value']}>
            {new Intl.NumberFormat(localeFullCode(props.locale), {
              style: 'decimal',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(fact.value)}
            <span className={TrustFactsStyle['trust-fact-value-plus']}>+</span>
          </p>
          <p className={TrustFactsStyle['trust-fact-description']}>
            {fact.description}
          </p>
        </div>
      ))}
      <div className={TrustFactsStyle['trust-fact']}>
        {/* TrustBox widget - Mini */}
        <div
          className="trustpilot-widget"
          data-locale={localeFullCode(props.locale)}
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id="57583e6f0000ff00058f82f6"
          data-style-height="78px"
          data-style-width="150px"
          data-token="d50c17a5-689e-40aa-8a6d-902c22a890d7">
          <a
            href={`https://${
              props.locale !== 'en' ? props.locale : 'www'
            }.trustpilot.com/review/igerent.com`}
            target="_blank"
            rel="noopener">
            Trustpilot
          </a>
        </div>
        {/* End TrustBox widget */}
      </div>
    </div>
  );
};

export default TrustFacts;
